export default {
  // Tab names
  'tab.main': 'メイン',
  'tab.producers': '生産機',
  'tab.achievements': '実績',
  'tab.prestige': '転生',
  'tab.settings': '設定',

  // Header
  'header.bps': '/秒',
  'header.stage': 'ステージ',
  'header.tap': 'TAP!',

  // Combo
  'combo.nice': 'Nice!',
  'combo.great': 'Great!',
  'combo.amazing': 'Amazing!',
  'combo.incredible': 'INCREDIBLE!',
  'combo.legendary': 'LEGENDARY!',
  'combo.label': 'コンボ',

  // Critical
  'crit.label': 'CRITICAL!',

  // Producers
  'producer.P1': '種',
  'producer.P2': '芽',
  'producer.P3': '苗木',
  'producer.P4': 'コーヒーの木',
  'producer.P5': '小規模農園',
  'producer.P6': '大規模農園',
  'producer.P7': 'ロースタリー',
  'producer.P8': 'コーヒー工場',
  'producer.P9': '輸出ハブ',
  'producer.P10': 'フランチャイズ',
  'producer.P11': 'コーヒー帝国',
  'producer.P12': 'コーヒー惑星',

  // Tap upgrades
  'upgrade.T1': '速い指',
  'upgrade.T2': '手袋',
  'upgrade.T3': '道具',
  'upgrade.T4': '機械',
  'upgrade.T5': 'ロボット',
  'upgrade.T6': 'ナノテクノロジー',
  'upgrade.T7': '量子収穫',
  'upgrade.T8': '時間歪曲',

  // Prestige upgrades
  'prestige.G1': '黄金の種',
  'prestige.G1.desc': 'BPS +1 基本',
  'prestige.G2': '肥沃な土壌',
  'prestige.G2.desc': 'タップ力 x1.5',
  'prestige.G3': '初心者割引',
  'prestige.G3.desc': 'P1~P3 コスト -50%',
  'prestige.G4': '一夜の成長',
  'prestige.G4.desc': 'オフライン効率 +20%',
  'prestige.G5': '促成栽培',
  'prestige.G5.desc': '全体 BPS x2',
  'prestige.G6': '幸運の手',
  'prestige.G6.desc': 'クリティカル確率 +3%',
  'prestige.G7': 'マスターバリスタ',
  'prestige.G7.desc': 'タップ力 x3',
  'prestige.G8': '卸売割引',
  'prestige.G8.desc': '全体コスト -20%',
  'prestige.G9': 'クイックスタート',
  'prestige.G9.desc': 'P1~P3 10個でスタート',
  'prestige.G10': 'プレミアムブレンド',
  'prestige.G10.desc': '全体 BPS x3',
  'prestige.G11': '時のコーヒー豆',
  'prestige.G11.desc': 'オフライン効率 100%',
  'prestige.G12': 'コーヒー王の王冠',
  'prestige.G12.desc': '全体生産 x2',
  'prestige.G13': 'ゴールデンビーンの木',
  'prestige.G13.desc': 'ゴールデンビーン獲得 +20%',
  'prestige.G14': 'タイムトラベル',
  'prestige.G14.desc': 'ステージ5からスタート',
  'prestige.G15': '無限のコーヒー豆',
  'prestige.G15.desc': '全体生産 x10',
  'prestige.G16': 'コーヒービッグバン',
  'prestige.G16.desc': 'ゴールデンビーン獲得 x2',

  // Star upgrades
  'star.S1': '初期資金',
  'star.S1.desc': 'スタート時100万豆',
  'star.S2': '永遠の黄金',
  'star.S2.desc': 'ゴールデンビーン獲得 x2 永久',
  'star.S3': '星の祝福',
  'star.S3.desc': '全体 BPS x5 永久',
  'star.S4': 'オートタップ',
  'star.S4.desc': '毎秒1回自動タップ',
  'star.S5': 'コンボマスター',
  'star.S5.desc': 'コンボ維持時間 3秒',
  'star.S6': '致命的一撃',
  'star.S6.desc': 'クリティカル倍率 x2',
  'star.S7': '宇宙の力',
  'star.S7.desc': '全体生産 x10 永久',
  'star.S8': '超越の星',
  'star.S8.desc': '昇天ボーナス x3',

  // Varieties
  'variety.V1': 'アラビカ',
  'variety.V2': 'ロブスタ',
  'variety.V3': 'リベリカ',
  'variety.V4': 'エクセルサ',
  'variety.V5': 'ゲイシャ',
  'variety.V6': 'コピ・ルアク',
  'variety.V7': 'ブルーマウンテン',
  'variety.V8': 'コナ',
  'variety.V9': 'イルガチェフェ',
  'variety.V10': 'ピーベリー',
  'variety.V11': 'マラゴジッペ',
  'variety.V12': 'セントヘレナ',

  // Stages
  'stage.1': 'おばあちゃんの庭',
  'stage.2': '小さな庭',
  'stage.3': 'コーヒー農園',
  'stage.4': 'ロースタリー',
  'stage.5': 'コーヒー工場',
  'stage.6': 'グローバルチェーン',
  'stage.7': 'コーヒー王国',

  // Roasting
  'roast.perfect': 'パーフェクトロースト！',
  'roast.dark': 'ダークロースト',
  'roast.medium': 'ミディアムロースト',
  'roast.light': 'ライトロースト',
  'roast.burnt': '焦げちゃった…',
  'roast.raw': '生焼け',
  'roast.tap': 'タップして止めて！',
  'roast.reward': '報酬',
  'roast.double': '広告を見て2倍！',
  'roast.collect': '受け取る',

  // Achievements
  'ach.tap1': '最初の一歩', 'ach.tap1.desc': '100回タップ',
  'ach.tap2': '勤勉な手', 'ach.tap2.desc': '1,000回タップ',
  'ach.tap3': 'タップマスター', 'ach.tap3.desc': '10,000回タップ',
  'ach.tap4': '伝説の指', 'ach.tap4.desc': '100,000回タップ',
  'ach.tap5': 'タップの神', 'ach.tap5.desc': '1,000,000回タップ',
  'ach.tap6': '速い手', 'ach.tap6.desc': '毎秒5回タップ',
  'ach.tap7': '雷の手', 'ach.tap7.desc': '毎秒10回タップ',
  'ach.tap8': '神の手', 'ach.tap8.desc': '毎秒15回タップ',
  'ach.tap9': 'コンボマニア', 'ach.tap9.desc': '20コンボ達成',
  'ach.tap10': '伝説のコンボ', 'ach.tap10.desc': '50コンボ達成',

  'ach.prod1': '初めての収穫', 'ach.prod1.desc': '合計1千豆収穫',
  'ach.prod2': '小さな成果', 'ach.prod2.desc': '合計10万豆収穫',
  'ach.prod3': '成長する農園', 'ach.prod3.desc': '合計1千万豆収穫',
  'ach.prod4': 'コーヒー大物', 'ach.prod4.desc': '合計10億豆収穫',
  'ach.prod5': 'コーヒー皇帝', 'ach.prod5.desc': '合計1兆豆収穫',
  'ach.prod6': '自動化開始', 'ach.prod6.desc': 'BPS 100達成',
  'ach.prod7': '工場稼働', 'ach.prod7.desc': 'BPS 1万達成',
  'ach.prod8': '産業革命', 'ach.prod8.desc': 'BPS 100万達成',
  'ach.prod9': 'グローバル生産', 'ach.prod9.desc': 'BPS 1億達成',
  'ach.prod10': '宇宙的生産', 'ach.prod10.desc': 'BPS 100億達成',

  'ach.bld1': '初心者農家', 'ach.bld1.desc': 'P1~P4 各1個保有',
  'ach.bld2': '中級農家', 'ach.bld2.desc': 'P1~P8 各1個保有',
  'ach.bld3': 'マスター農家', 'ach.bld3.desc': '全生産機保有',
  'ach.bld4': '集中投資', 'ach.bld4.desc': '1種類10個保有',
  'ach.bld5': '大量購入', 'ach.bld5.desc': '1種類25個保有',
  'ach.bld6': 'コレクター', 'ach.bld6.desc': '1種類50個保有',
  'ach.bld7': '独占王', 'ach.bld7.desc': '1種類100個保有',
  'ach.bld8': '事業拡大', 'ach.bld8.desc': '合計100個の生産機',
  'ach.bld9': '企業帝国', 'ach.bld9.desc': '合計500個の生産機',
  'ach.bld10': '世界制覇', 'ach.bld10.desc': '合計1000個の生産機',

  'ach.pres1': '初めての転生', 'ach.pres1.desc': '1回転生',
  'ach.pres2': '繰り返しの味', 'ach.pres2.desc': '3回転生',
  'ach.pres3': '転生マスター', 'ach.pres3.desc': '5回転生',
  'ach.pres4': '終わりなき循環', 'ach.pres4.desc': '10回転生',
  'ach.pres5': '永遠の輪', 'ach.pres5.desc': '20回転生',
  'ach.pres6': '輪廻の達人', 'ach.pres6.desc': '50回転生',
  'ach.pres7': '黄金の収穫', 'ach.pres7.desc': '一度に10ゴールデンビーン',
  'ach.pres8': '黄金の嵐', 'ach.pres8.desc': '一度に100ゴールデンビーン',
  'ach.pres9': 'スピードランナー', 'ach.pres9.desc': '30分以内に転生',
  'ach.pres10': '雷速転生', 'ach.pres10.desc': '15分以内に転生',

  'ach.spec1': 'チェリーハンター', 'ach.spec1.desc': 'ゴールデンチェリー1回タップ',
  'ach.spec2': 'チェリーマニア', 'ach.spec2.desc': 'ゴールデンチェリー10回タップ',
  'ach.spec3': 'チェリーマスター', 'ach.spec3.desc': 'ゴールデンチェリー50回タップ',
  'ach.spec4': 'ロースト入門', 'ach.spec4.desc': 'パーフェクトロースト1回',
  'ach.spec5': 'ロースト達人', 'ach.spec5.desc': 'パーフェクトロースト10回',
  'ach.spec6': '品種コレクター', 'ach.spec6.desc': '5種類の品種収集',
  'ach.spec7': 'コーヒー博士', 'ach.spec7.desc': '12種類全品種収集',
  'ach.spec8': 'コツコツ農家', 'ach.spec8.desc': '合計1時間プレイ',
  'ach.spec9': 'コーヒー中毒', 'ach.spec9.desc': '合計24時間プレイ',
  'ach.spec10': '7日連続', 'ach.spec10.desc': '7日連続ログイン',

  'ach.mile1': 'コーヒー農園主', 'ach.mile1.desc': 'ステージ3到達',
  'ach.mile2': 'コーヒー事業家', 'ach.mile2.desc': 'ステージ5到達',
  'ach.mile3': 'コーヒー王', 'ach.mile3.desc': 'ステージ7到達',
  'ach.mile4': '超越者', 'ach.mile4.desc': '初の星の昇天',
  'ach.mile5': '完璧主義者', 'ach.mile5.desc': '50個の実績達成',

  // Achievement categories
  'ach.cat.tapping': 'タップ',
  'ach.cat.production': '生産',
  'ach.cat.producers': '生産機',
  'ach.cat.prestige': '転生',
  'ach.cat.special': '特殊',
  'ach.cat.milestone': 'マイルストーン',

  // Prestige panel
  'prestige.title': 'ロースト転生',
  'prestige.desc': '転生してゴールデンビーンを獲得し、より強くスタート！',
  'prestige.goldenBeans': 'ゴールデンビーン',
  'prestige.expected': '予想獲得量',
  'prestige.rebirth': '転生',
  'prestige.upgrades': '転生アップグレード',
  'prestige.locked': 'ステージ7到達で解放',
  'prestige.adBonus': '広告を見て +30%',

  // Ascension panel
  'ascend.title': '星の昇天',
  'ascend.desc': '昇天して星の塵を獲得し、すべてを超越！',
  'ascend.starDust': '星の塵',
  'ascend.expected': '予想獲得量',
  'ascend.ascend': '昇天',
  'ascend.upgrades': '星のアップグレード',
  'ascend.locked': '転生10回 + ゴールデンビーン100個必要',

  // Settings
  'settings.bgm': 'BGM',
  'settings.sfx': '効果音',
  'settings.vibration': '振動',
  'settings.language': '言語',
  'settings.reset': 'データ初期化',
  'settings.resetConfirm': '本当にすべてのデータを削除しますか？',
  'settings.credits': 'クレジット',
  'settings.version': 'バージョン',

  // Boost buttons
  'boost.tap': 'タップブースト',
  'boost.bps': '生産ブースト',

  // Offline
  'offline.title': 'おかえりなさい！',
  'offline.earned': 'オフライン収益',
  'offline.time': '離れていた時間',
  'offline.collect': '受け取る',
  'offline.adX3': '広告を見て x3',

  // General
  'buy': '購入',
  'max': '最大',
  'level': 'Lv.',
  'locked': 'ロック',
  'owned': '保有',
  'on': 'オン',
  'off': 'オフ',
} as const;
